import { Injectable } from '@angular/core';
import { SessionStorageService } from '../session-storage/session-storage.service';

@Injectable({ providedIn: 'root' })
export class FiltersPersistenceService {
  constructor(private sessionStorage: SessionStorageService) {}

  save<T>(key: string, value: T): void {
    try {
      this.sessionStorage.set(key, value);
    } catch (error: unknown) {
      console.warn('[FiltersPersistenceService] Failed to save filters', error);
    }
  }

  restore<T>(key: string, defaultValue: T): T {
    const stored = this.sessionStorage.get<Partial<T>>(key);

    if (!stored) {
      return defaultValue;
    }

    try {
      return {
        ...defaultValue,
        ...stored
      };
    } catch (error: unknown) {
      console.warn(
        '[FiltersPersistenceService] Failed to restore filters',
        error
      );
      return defaultValue;
    }
  }

  clear(key: string): void {
    try {
      this.sessionStorage.remove(key);
    } catch (error: unknown) {
      console.warn(
        '[FiltersPersistenceService] Failed to clear filters',
        error
      );
    }
  }
}
